import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { usePermissoes } from '@/contexts/PermissoesContext';

interface ProtectedRouteProps {
  children:      React.ReactNode;
  formularioId?: number; // se informado, verifica se pode ler
}

export function ProtectedRoute({ children, formularioId }: ProtectedRouteProps) {
  const { user, loading: authCarregando }        = useAuth();
  const { temPermissao, carregando: permCarregando, revalidar } = usePermissoes();
  const location = useLocation();

  // Antes de negar acesso, revalida as permissões UMA vez: cobre o caso de a
  // permissão ter sido concedida em /config/perfis depois do login (cache do
  // contexto desatualizado). Usa revalidar (silencioso) e NÃO recarregar — o
  // recarregar liga "carregando", que faria o ProtectedRoute do layout trocar
  // a árvore pelo spinner e desmontar/remontar este componente (loop infinito).
  const [retryPermissao, setRetryPermissao] = useState<'idle' | 'feito'>('idle');
  const negado =
    !!user && !authCarregando && !permCarregando &&
    !!formularioId && !temPermissao(formularioId, 'ler');

  useEffect(() => {
    setRetryPermissao('idle');
  }, [formularioId]);

  useEffect(() => {
    if (negado && retryPermissao === 'idle') {
      revalidar().finally(() => setRetryPermissao('feito'));
    }
  }, [negado, retryPermissao, revalidar]);

  if (authCarregando || permCarregando || (negado && retryPermissao === 'idle')) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (negado) {
    return <Navigate to="/sem-permissao" replace />;
  }

  return <>{children}</>;
}
